import React from 'react';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { v4 as uuidV4 } from 'uuid';
import { Divider } from '@material-ui/core';
import { useHistory } from 'react-router';
import { getDate } from 'app/shared/util/date-utils';
import StoreIcon from '@material-ui/icons/Store';
import Loader from '../../spb/loader/loader';
import AvatarWithBadge from '../../mobile/avatar-with-badge/avatar-with-badge';
import './dialog.scss';

export interface SimpleDialogProps {
  open: boolean;
  selectedValue?: string;
  setOpen: (value: boolean) => void;
  data?: any;
  avatar?: any;
  selectSellingPoint?: any;
  loading?: any;
}

function DialogDesktop(props: SimpleDialogProps) {
  const { setOpen, open, data, avatar, selectSellingPoint, loading } = props;
  const history = useHistory();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog disableEscapeKeyDown={true} aria-labelledby="simple-dialog-title" open={open} fullScreen={false}>
      <DialogTitle id="simple-dialog-title">{'Sélectionner un magasin'}</DialogTitle>
      <Divider />
        <List>
          {Object.values(data).map((el: any) => (
            <React.Fragment key={uuidV4()}>
              <ListItem
                className="popup-item"
                button
                onClick={() => {
                  selectSellingPoint(el);
                  history.push({
                    pathname: `/`,
                  });
                  handleClose();
                }}
                key={uuidV4()}
              >
                <ListItemAvatar>
                  <StoreIcon />
                </ListItemAvatar>
                <div className={'d-flex flex-column'}>
                  <p className="title-text">{`Magasin :  ${el.name}`}</p>
                </div>
              </ListItem>
              <br />
            </React.Fragment>
          ))}
        </List>
    </Dialog>
  );
}
export default DialogDesktop;
